module.exports = __webpack_public_path__ + "img/53.c5aaaa4d.jpg";